/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import api from './api';
import { API_ENDPOINTS } from '../api/endpoints';

export const messageService = {
  getMessages: () => api.get(API_ENDPOINTS.MESSAGES.LIST),
  getMessageThread: (id: string | number) => api.get(API_ENDPOINTS.MESSAGES.THREAD(id)),
  sendMessage: (data: any) => api.post(API_ENDPOINTS.MESSAGES.SEND, data),
};
